module.exports = __webpack_public_path__ + "img/public/SiteIcons/creditIcon.svg?fd978ba9";